import { createFeatureSelector, createSelector } from '@ngrx/store';
import { QuizQuestionState } from '../reducers/quiz-question.reducer';
import { QUIZ_QUESTION_FEATURE_KEY } from '../keys';

const selectState = createFeatureSelector<QuizQuestionState>(QUIZ_QUESTION_FEATURE_KEY);

export const selectLoaded = (id: string) => createSelector(selectState, (state: QuizQuestionState) => state.entries[id]?.loaded ?? null);
export const selectLoading = (id: string) => createSelector(selectState, (state: QuizQuestionState) => state.entries[id]?.loading ?? false);
export const selectQuizQuestion = (id: string) => createSelector(selectState, (state: QuizQuestionState) => state.entries[id]?.quizQuestion ?? null);
export const selectSaving = createSelector(selectState, (state: QuizQuestionState) => state.saving);
export const selectSaved = createSelector(selectState, (state: QuizQuestionState) => state.saved);
export const selectError = (id: string) => createSelector(selectState, (state: QuizQuestionState) => state.entries[id]?.error ?? null);
export const selectCreatedId = createSelector(selectState, (state: QuizQuestionState) => state.createdId);
